import { render } from "./Lockbox.vue?vue&type=template&id=6752532c"
import script from "./Lockbox.vue?vue&type=script&lang=js"
export * from "./Lockbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__